<template>
  <div class="category-page">
    <div class="filter-group">
      <div class="filter-title">作品类型:</div>
      <div class="filter-options">
        <span 
          v-for="tag in typeTags" 
          :key="tag"
          :class="{ active: selectedType === tag }"
          @click="selectType(tag)"
        >
          {{ tag }}
        </span>
      </div>
    </div>
    <div class="filter-group">
      <div class="filter-title">付费模式:</div>
      <div class="filter-options">
        <span 
          v-for="tag in paymentTags" 
          :key="tag"
          :class="{ active: selectedPayment === tag }"
          @click="selectPayment(tag)"
        >
          {{ tag }}
        </span>
      </div>
    </div>
    <div class="works-list">
      <div class="work-card" v-for="item in filteredWorks" :key="item.id" @click="goDetail(item.id)">
        <img :src="item.cover" class="work-cover" />
        <div class="work-info">
          <h3>{{ item.title }}</h3>
          <p>作者：{{ item.author }}</p>
          <div class="tags">
            <span class="tag">{{ item.type }}</span>
            <span class="tag">{{ item.payment }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getCategoryComics, BASE_URL } from '../api/index';
import youthModeManager from '@/utils/youthMode';

export default {
  name: 'CategoryPage',
  data() {
    return {
      selectedType: '全部',
      selectedPayment: '全部',
      typeTags: ['全部', '恋爱', '古装', '奇幻', '悬疑', '科幻', '热血', '都市', '校园', '治愈', '冒险'],
      paymentTags: ['全部', '免费', '付费'],
      allWorks: []
    }
  },
  created() {
    this.fetchCategoryData();
  },
  computed: {
    filteredWorks() {
      return this.allWorks.filter(work => {
        const typeMatch = this.selectedType === '全部' || work.type === this.selectedType;
        const paymentMatch = this.selectedPayment === '全部' || work.payment === this.selectedPayment;
        return typeMatch && paymentMatch;
      });
    }
  },
  methods: {
    async fetchCategoryData() {
      try {
        await youthModeManager.ensureReady();
        const res = await getCategoryComics({ page: 1, limit: 100 });
        if (res.data && res.data.code === 1) {
          this.allWorks = youthModeManager.filterForYouth(res.data.data.list).map(item => ({
            id: item.id,
            cover: item.cover.startsWith('http') ? item.cover : BASE_URL + item.cover,
            title: item.title,
            author: item.author,
            desc: item.description,
            type: this.getRandomType(),
            payment: this.getRandomPayment()
          }));
        }
      } catch (e) { /* ignore */ }
    },
    getRandomType() {
      const types = ['恋爱', '古装', '奇幻', '悬疑', '科幻', '热血', '都市', '校园', '治愈', '冒险'];
      return types[Math.floor(Math.random() * types.length)];
    },
    getRandomPayment() {
      const payments = ['免费', '付费'];
      return payments[Math.floor(Math.random() * payments.length)];
    },
    selectType(tag) {
      this.selectedType = tag;
    },
    selectPayment(tag) {
      this.selectedPayment = tag;
    },
    goDetail(id) {
      this.$router.push({ name: 'ComicDetail', params: { id } });
    }
  }
}
</script>

<style scoped>
.category-page {
  width: 100%;
  min-height: 100%;
  background: var(--bg);
  position: relative;
}

.filter-group {
  margin: 20px 0 0 20px;
}
.filter-title {
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 8px;
  color: var(--text);
}
.filter-options {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
}
.filter-options span {
  background: var(--surface);
  border: 1px solid var(--border);
  border-radius: 16px;
  padding: 6px 18px;
  font-size: 16px;
  color: var(--text);
  font-weight: 500;
  cursor: pointer;
  transition: background var(--t-fast), color var(--t-fast), transform var(--t-fast), border-color var(--t-fast);
}
.filter-options span:hover {
  background: var(--brand-soft);
  color: var(--brand);
  border-color: var(--brand-soft);
  transform: translateY(-1px);
}
.filter-options span.active {
  background: var(--brand);
  color: #fff;
  border-color: var(--brand);
}
.works-list {
  display: grid;
  grid-template-columns: repeat(8, 1fr);
  gap: 15px;
  margin: 30px 20px 0 20px;
  padding-bottom: 30px;
  width: 100%;
}
.work-card {
  background: var(--surface-2);
  border: 1px solid var(--border);
  border-radius: 8px;
  padding: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  transition: transform var(--t-fast), border-color var(--t-fast);
  cursor: pointer;
}
.work-card:hover {
  transform: translateY(-2px);
  border-color: var(--brand-soft);
}
.work-cover {
  width: 100%;
  height: 140px;
  object-fit: cover;
  border-radius: 6px;
  margin-bottom: 8px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
}
.work-info {
  text-align: center;
  width: 100%;
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.work-info h3 {
  font-size: 14px;
  margin: 0 0 4px 0;
  font-weight: 600;
  color: var(--text);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.work-info p {
  font-size: 11px;
  margin: 0 0 2px 0;
  color: var(--text-dim);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.work-info .desc {
  color: var(--text-dim);
  font-size: 10px;
  margin-bottom: 6px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.tags {
  display: flex;
  gap: 3px;
  flex-wrap: wrap;
  justify-content: center;
}
.tag {
  background: rgba(255, 255, 255, 0.2);
  color: #ffffff;
  padding: 2px 5px;
  border-radius: 3px;
  font-size: 9px;
  font-weight: 500;
}

/* 与排行榜一致的响应式列数 */
@media (max-width: 1600px) {
  .works-list {
    grid-template-columns: repeat(6, 1fr);
  }
}
@media (max-width: 1200px) {
  .works-list {
    grid-template-columns: repeat(4, 1fr);
  }
}
@media (max-width: 768px) {
  .works-list {
    grid-template-columns: repeat(3, 1fr);
    gap: 12px;
  }
  .work-cover {
    height: 120px;
  }
  .work-info h3 {
    font-size: 12px;
  }
  .work-info p {
    font-size: 10px;
  }
}
@media (max-width: 480px) {
  .works-list {
    grid-template-columns: repeat(2, 1fr);
    gap: 10px;
    margin: 20px 15px 0 15px;
  }
  .work-cover {
    height: 100px;
  }
  .work-info h3 {
    font-size: 11px;
  }
  .work-info p {
    font-size: 9px;
  }
}
</style> 